import styled from 'styled-components'
import { white } from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'

/**
 *
 */

export const Wrapper = styled.form`
  ${flexCol}
  background-color: ${white};
`
